import { useState, useEffect } from 'react'
import axios from 'axios'
import sanitize from 'sanitize-filename'
import httpClient from '../httpClient'

import ImagesUpload from '../components/PrintOrder/PrintOrderCreate/ImagesUpload'
import NoImages from '../components/PrintOrder/PrintOrderCreate/NoImages'
import Loading from '../components/common/Loading'
import ImagePreview from '../components/PrintOrder/PrintOrderCreate/ImagePreview'
import OrderInit from '../components/PrintOrder/PrintOrderCreate/OrderInit'
import SelectProducts from '../components/PrintOrder/PrintOrderCreate/SelectProducts'
import { apiErrorMessage } from '../lib/utils'
import ProductSelectionSidebar from '../components/ProductSelection/ProductSelectionSidebar'

const PrintOrderCreate = () => {
  const [currentOrder, setCurrentOrder] = useState(null)
  const [isDisabled, setIsDisabled] = useState(true);
  const [uploadsPreview, setUploadPreview] = useState([])
  const [loading, setLoading] = useState(false)

  const [apiError, setApiError] = useState(null)

  useEffect(() => {
    setIsDisabled(currentOrder === null);
  }, [currentOrder]);

  const handleCreateOrder = async (orderName) => {
    try {
      setLoading('Creating order...')
      setApiError(null)
      const order = await httpClient.post('lab_orders', {
        orderName,
      })
      setCurrentOrder(order)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setApiError(apiErrorMessage(err))
    }
  }

  if (loading) {
    return <Loading message={typeof loading === 'string' ? loading : 'Loading...'} />
  }

  return (
    <div className="sub-grid-container-print-order">
      <div className="print-order-sidebar-container--centered">
        <div className="print-order-sidebar grid absolute">
          <div className="accordion-item-block">
            <OrderInit onCreate={handleCreateOrder} order={currentOrder} loading={loading} apiError={apiError} onDismissError={() => setApiError(null)} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrintOrderCreate
